import React from "react";
import { motion } from "framer-motion";
import { Helmet } from "react-helmet-async";
import solonetImg from "../assets/solonet.jpg";
import icechestImg from "../assets/icechestwater.jpg";
import timberImg from "../assets/timber.jpg";

const Ventures = () => {
  const title = "Business Ventures | Kwame O. Sarfo";
  const description =
    "Explore the business ventures of Kwame O. Sarfo — including Solonet Properties, Ice Chest Mineral Water, and Global Timber Ltd, contributing to Ghana’s economic and sustainable development.";
  const keywords =
    "Kwame O. Sarfo, Solonet Properties, Ice Chest Mineral Water, Global Timber Ltd, Ghana entrepreneur, real estate, bottled water, timber export, Ghana business";

  const ventures = [
    {
      id: 1,
      name: "Solonet Properties",
      image: solonetImg,
      description:
        "A premier real estate company in Ghana developing luxurious residential and commercial properties with modern architecture and sustainable designs.",
      link: "https://solonetproperties.com",
    },
    {
      id: 2,
      name: "Ice Chest Mineral Water",
      image: icechestImg,
      description:
        "A trusted mineral water brand which produces sachet water, bottled water and dispenser bottled water providing pure, refreshing, and hygienically processed mineral water to communities across Ghana.",
      link: "https://icechestwater.com",
    },
    {
      id: 3,
      name: "Global Timber Ltd",
      image: timberImg,
      description:
        "A timber export company that trades high-quality Ghanaian hardwood to international markets, supporting sustainable forestry practices.",
      link: "https://example.com/global-timber",
    },
  ];

  return (
    <section
      id="ventures"
      className="relative bg-[#0a0a0a] text-white py-20 px-6 md:px-20 overflow-hidden"
    >
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://solonetproperties.com/ventures" />
      </Helmet>

      {/* Header */}
      <div className="max-w-4xl mx-auto text-center mb-16">
        <motion.h1
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
          className="text-5xl md:text-6xl font-playfair text-[#d4af37]"
        >
          Business Ventures
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2 }}
          viewport={{ once: true }}
          className="mt-4 text-gray-400 max-w-3xl mx-auto"
        >
          Through innovation, integrity, and impact, Kwame O. Sarfo has
          established businesses that drive growth and sustainability across
          Ghana’s private sector.
        </motion.p>
      </div>

      {/* Ventures Grid */}
      <div className="grid md:grid-cols-3 gap-10 max-w-6xl mx-auto">
        {ventures.map((venture, index) => (
          <motion.div
            key={venture.id}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: index * 0.2 }}
            viewport={{ once: true }}
            className="bg-[#111]/90 border border-[#d4af37]/20 rounded-2xl overflow-hidden shadow-[0_0_25px_rgba(212,175,55,0.15)] hover:shadow-[0_0_40px_rgba(212,175,55,0.3)] transition-all duration-300 flex flex-col"
          >
            <img
              src={venture.image}
              alt={venture.name}
              className="w-full h-56 object-cover"
            />
            <div className="p-6 flex flex-col flex-grow">
              <h2 className="text-xl font-playfair text-[#d4af37] mb-2">
                {venture.name}
              </h2>
              <p className="text-gray-300 flex-grow">{venture.description}</p>
              <a
                href={venture.link}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-4 inline-block text-[#d4af37] hover:underline text-sm"
              >
                Learn More →
              </a>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Ventures;
